/* ========================================
   DAYS THEME: NEWSLETTER BANNER SCRIPT
   ======================================== */

class DaysNewsletterBanner {
  constructor() {
    this.banner = document.getElementById('days-newsletter-banner');
    this.closeBtn = document.getElementById('days-newsletter-close');
    this.form = document.getElementById('DaysNewsletterForm');

    if (!this.banner) return;

    this.init();
  }

  init() {
    // Mostrar banner sempre (sem verificar localStorage)
    this.banner.classList.add('is-visible');

    // Event listener para fechar
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Event listener para o formulário
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
  }

  close() {
    // Fechar apenas visualmente (não salvar no localStorage)
    this.banner.classList.add('is-closed');
    document.body.classList.add('days-newsletter-closed');
  }

  handleSubmit(e) {
    // O formulário será enviado normalmente para o Shopify
    // Após o submit bem-sucedido, o banner pode ser fechado automaticamente
    // (isso acontecerá no reload da página se você quiser)
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DaysNewsletterBanner();
  });
} else {
  new DaysNewsletterBanner();
}
